export enum ProviderAccordionSelectedTab {
  NetworkProviders,
  OutOfNetworkProviders,
  TargetedProviders,
}

export enum ProviderSourceOfSelection {
  Accordion,
  Map,
  Unknown
}

export enum ProvidersSortOptions {
  Alphabetical,
  ReverseAlphabetical,
  ServesHighToLow,
  ServesLowToHigh,
  GainsHighToLow,
  GainsLowToHigh,
  ImpactsHighToLow,
  ImpactsLowToHigh
}

export enum ImpactProvidersFilterOptions {
  Market = 'market',
  Prospect = 'prospect',
  Target = 'target',
  TargetedMarket = 'targetedMarket',
  TargetedProspect = 'targetedProspect'
}
